import { getIdToken } from "./authService";
import { DOCUMENT_CENTER_URL, DOCUMENT_URL } from "./url_api_helper";

async function downloadDocuments(documentIds = [], nameFile = "arquivos.zip", view) {
  if (!documentIds.length) return;
  
  const token = await getIdToken();
  if (!token) throw new Error("Token não informado");

  const queryString = documentIds.map(id => `documentIds=${id}`).join("&");
  let urlBase;
  if (view === "DocumentCenter") {
    urlBase = DOCUMENT_CENTER_URL.getDocumentCenterDownloadZip();
  } else {
    urlBase = DOCUMENT_URL.getDocumentDownloadZip();
  }
  
  const url = `${urlBase}?${queryString}`;
  
  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `bearer ${token}`,
    },
  });

  if (!response.ok) throw new Error("Download failed");

  const blob = await response.blob();
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = nameFile;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(link.href);

  return true;
}

export default downloadDocuments;